import {theme} from 'assets/styles/theme'
import styled from 'styled-components'

export const Wrapper = styled.div`
  height: 150px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;

  @media (max-width: 768px) {
    height: auto;
  }
`

export const HeaderText = styled.h4`
  font-family: Roboto;
  font-weight: ${theme.fontWeight.normal};
  font-size: ${theme.fontSize.xl};
  line-height: ${theme.lineHeight.tight};
  margin-bottom: 10px;

  @media (max-width: 768px) {
    margin-bottom: 5px;
  }
`

export const DropArea = styled.div`
  width: ${theme.width.full};
  height: 110px;
  border-radius: ${theme.borderRadius.lg};
  border: 1px dashed ${theme.colors.solar_21.gray};
  padding: ${theme.spacing[4]} 0;
  background-color: ${theme.colors.solar_21.gray_light};
  display: grid;
  grid-template-columns: 80px 1fr;
  cursor: pointer;
`

export const IconArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  & > input {
    display: none;
  }
`

export const TextArea = styled.div`
  height: ${theme.width.full};
  display: flex;
  flex-direction: column;
  justify-content: center;
`

export const InfoText = styled.h5`
  font-family: Roboto;
  font-weight: ${theme.fontWeight.medium};
  font-size: ${theme.fontSize.xl};
  line-height: ${theme.lineHeight.tight};
`

export const MimeText = styled.h5`
  font-family: Roboto;
  font-weight: ${theme.fontWeight.light};
  font-size: ${theme.fontSize.xl};
  line-height: ${theme.lineHeight.tight};
`

export const FileArea = styled.div`
  width: ${theme.width.full};
  height: 110px;
  border: 1px solid ${theme.colors.green[500]};
  border-radius: ${theme.borderRadius.lg};
  padding: ${theme.spacing[4]} 0;
  background-color: ${theme.colors.white};
  display: grid;
  grid-template-columns: 80px 1fr 80px;
  align-items: center;

  @media (max-width: 768px) {
    height: auto;
  }
`

export const FileName = styled.h5`
  font-family: Roboto;
  font-weight: ${theme.fontWeight.normal};
  font-size: ${theme.fontSize.xl};
  color: ${theme.colors.solar_21.gray_slight_light};
  line-height: ${theme.lineHeight.tight};
`

export const ButtonWrapper = styled.div`
  width: ${theme.width.full};
  display: flex;
  justify-content: center;
`

export const RemoveButton = styled.button`
  width: 60px;
  height: 60px;
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: inherit;
  border: none;

  &:hover {
    background-color: ${theme.colors.solar_21.gray_light};
  }
`
